'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'bath';
var width = 512;
var height = 512;
var aliases = [128705,"bathtub"];
var unicode = 'f2cd';
var svgPathData = 'M48 0l-16 0 0 256-32 0 0 32 32 0 0 80c0 30.5 12.2 58.2 32 78.4l0 65.6 32 0 0-42.8c14.5 6.9 30.8 10.8 48 10.8l224 0c17.2 0 33.5-3.9 48-10.8l0 42.8 32 0 0-65.6c19.8-20.2 32-47.9 32-78.4l0-80 32 0 0-32-448 0 0-224 41.4 0 33.7 33.7c-7 11.1-11 24.2-11 38.3 0 20.2 8.3 38.5 21.8 51.6l-1.1 1.1-11.3 11.3 22.6 22.6 11.3-11.3 104-104 11.3-11.3-22.6-22.6-11.3 11.3-1.1 1.1c-13.1-13.4-31.4-21.8-51.6-21.8-14.1 0-27.2 4-38.3 11L123.3 4.7 118.6 0 48 0zM229 76.4L172.4 133c-7.6-7.3-12.4-17.6-12.4-29 0-22.1 17.9-40 40-40 11.4 0 21.7 4.8 29 12.4zM64 288l384 0 0 80c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBath = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;